import { FC } from "react"
import { StatisticsObjectType } from "./types";
import CustomLineChart from "../customLineChart";
import CustomButtonRight from "../customButtonRight";

const CaseVolumeHorizontal: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  return (
    <div className="row">
      <div className="col-12 col-xl-9 col-lg-8 mb-3">
        <CustomLineChart title={"Case Volume"} LineChartObject={StatisticsObjectType.case_volume}/>
      </div>

      <div className="col-12 col-xl-3 col-lg-4 d-flex">
        <CustomButtonRight StatisticsObjectType={StatisticsObjectType}/>
      </div>
    </div>
  )
}
export default CaseVolumeHorizontal;
